import { render, staticRenderFns } from "./Recuperarpass.vue?vue&type=template&id=445ee812&"
import script from "./Recuperarpass.vue?vue&type=script&lang=js&"
export * from "./Recuperarpass.vue?vue&type=script&lang=js&"
import style0 from "./Recuperarpass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports